import React from 'react';

// We'll reuse the card, but give it a fixed width for the slider
const PackageCardSlider = ({ image, title, price }) => {
    const styles = {
        card: {
            flex: '0 0 320px', // Don't grow, don't shrink, base width of 320px
            marginRight: '1.5rem',
            position: 'relative',
            borderRadius: '12px',
            overflow: 'hidden',
            color: 'white',
            height: '450px'
        },
        image: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
        },
        overlay: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%)',
            padding: '4rem 1.5rem 1.5rem 1.5rem'
        },
        title: {
            fontSize: '1.5rem',
            fontWeight: 'bold',
            margin: '0 0 0.5rem 0',
        },
        price: {
            fontSize: '1.2rem'
        }
    };
    return (
        <div style={styles.card}>
            <img src={image} alt={title} style={styles.image} />
            <div style={styles.overlay}>
                <h3 style={styles.title}>{title}</h3>
                <p style={styles.price}>From ${price}</p>
            </div>
        </div>
    );
}

const FeaturedPackages2 = () => {
  const packages = [
    { image: 'https://images.pexels.com/photos/1618269/pexels-photo-1618269.jpeg', title: 'Amazing Thailand', price: '1200' },
    { image: 'https://images.pexels.com/photos/2161449/pexels-photo-2161449.jpeg', title: 'Swiss Alps', price: '2500' },
    { image: 'https://images.pexels.com/photos/3225528/pexels-photo-3225528.jpeg', title: 'Bali Escape', price: '1500' },
    { image: 'https://images.pexels.com/photos/2404949/pexels-photo-2404949.jpeg', title: 'Kyoto, Japan', price: '3000' },
    { image: 'https://images.pexels.com/photos/21014/pexels-photo.jpg', title: 'Santorini Views', price: '2200' },
  ];

  const styles = {
    section: {
      padding: '4rem 0',
      backgroundColor: '#f8f9fa',
      overflowX: 'hidden', // Hide horizontal scrollbar from the main body
    },
    header: {
        textAlign: 'center',
        marginBottom: '3rem',
    },
    title: {
      fontSize: '2.5rem',
    },
    sliderContainer: {
        display: 'flex',
        overflowX: 'auto', // Enable horizontal scrolling
        padding: '0 2rem 1.5rem 2rem', // Add padding for looks and scrollbar space
        // Hide the scrollbar for a cleaner look
        scrollbarWidth: 'none', /* Firefox */
        'msOverflowStyle': 'none',  /* IE and Edge */
        '::-webkit-scrollbar': {
            display: 'none' /* Chrome, Safari, Opera */
        }
    },
  };

  return (
    <section style={styles.section}>
      <div style={styles.header}>
        <h2 style={styles.title}>Popular Destinations</h2>
      </div>
      <div style={styles.sliderContainer}>
        {packages.map((pkg, index) => (
          <PackageCardSlider key={index} {...pkg} />
        ))}
      </div>
    </section>
  );
};

export default FeaturedPackages2;